export type HostedCheckoutMethod = 'visa' | 'google_pay' | 'apple_pay';

export function isHostedCheckoutMethod(method?: string | null): method is HostedCheckoutMethod {
  const value = String(method || '').toLowerCase();
  return value === 'visa' || value === 'google_pay' || value === 'apple_pay';
}

export function checkoutMethodToMpgsWallet(
  method?: string | null
): 'GOOGLE_PAY' | 'APPLE_PAY' | null {
  const value = String(method || '').toLowerCase();
  if (value === 'google_pay') return 'GOOGLE_PAY';
  if (value === 'apple_pay') return 'APPLE_PAY';
  return null;
}

export function paymentMethodFromMpgsOrder(
  order: unknown,
  fallback: string = 'visa'
): HostedCheckoutMethod {
  const record = order && typeof order === 'object' ? (order as Record<string, any>) : {};
  const provider = String(
    record.walletProvider ||
      record?.sourceOfFunds?.provided?.card?.devicePayment?.walletProvider ||
      record?.sourceOfFunds?.type ||
      ''
  ).toUpperCase();
  if (provider.includes('GOOGLE')) return 'google_pay';
  if (provider.includes('APPLE')) return 'apple_pay';
  return isHostedCheckoutMethod(fallback) ? fallback : 'visa';
}
